// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/rbac.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CheckPermissionRequest, CheckPermissionResponse, CreateRoleRequest, DeleteRoleRequest, GetRoleRequest, ListRolesRequest, ListRolesResponse, RoleDefinition, UpdateRoleRequest } from "./rbac_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.RoleService
 */
export const RoleService = {
  typeName: "omnios.v1.RoleService",
  methods: {
    /**
     * @generated from rpc omnios.v1.RoleService.ListRoles
     */
    listRoles: {
      name: "ListRoles",
      I: ListRolesRequest,
      O: ListRolesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.RoleService.GetRole
     */
    getRole: {
      name: "GetRole",
      I: GetRoleRequest,
      O: RoleDefinition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.RoleService.CreateRole
     */
    createRole: {
      name: "CreateRole",
      I: CreateRoleRequest,
      O: RoleDefinition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.RoleService.UpdateRole
     */
    updateRole: {
      name: "UpdateRole",
      I: UpdateRoleRequest,
      O: RoleDefinition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.RoleService.DeleteRole
     */
    deleteRole: {
      name: "DeleteRole",
      I: DeleteRoleRequest,
      O: RoleDefinition,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.RoleService.CheckPermission
     */
    checkPermission: {
      name: "CheckPermission",
      I: CheckPermissionRequest,
      O: CheckPermissionResponse,
      kind: MethodKind.Unary,
    },
  }
};

